import React from "react";
import Modal from "react-modal";
import "./CustomDatePicker.scss"

const OrderDateOptions = ({ isOpen, closeModal, handleToday, handleYesterday, handleCustom }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Order Date Options"
    >
      <h2>Order Date</h2>
  
        <div>
        <button className="Todaybutton" onClick={handleToday}>Today</button>
      </div>
      <div>
        <button className="Yesterdaybutton" onClick={handleYesterday}>Yesterday</button>
      </div>
        <button className="custombutton"  onClick={handleCustom}>Custom</button>
      {/* <button className="Selectdatecancelbutton"  onClick={closeModal}>Close</button> */}

    
    </Modal>
  );
};

export default OrderDateOptions;
